import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from '../ApiEvs.service';

@Injectable()
export class AdminUserService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  list(tenant_id, query?: any) {
    return this.get('/v2/admin/settings/' + tenant_id + '/users', query);
  }
  group(tenant_id, query?: any) {
    return this.get('/v2/admin/settings/' + tenant_id + '/groups', query);
  }
  create(tenant_id, body: any) {
    return this.post('/v2/admin/settings/' + tenant_id + '/create-user', body);
  }
  active(tenant_id, id, body) {
    return this.put('/v2/admin/settings/' + tenant_id + '/active-user/' + id, body);
  }
  resetPassword(tenant_id, id, body) {
    return this.post('/v2/admin/settings/' + tenant_id + '/reset-password/' + id, body);
  }
  signIn(tenant_id, body) {
    return this.post('/v2/admin/settings/' + tenant_id + '/sign-in-agent', body);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/admins/user.service.ts